import api from './client';

// Phase 31 — Wallet ledger + summary (read-only projection from purchases,
// payouts and refund_requests).

export const getWalletLedger = async ({ filter = 'all', page = 1, pageSize = 50 } = {}) => {
  const res = await api.get('/wallet/ledger', {
    params: { filter, page, page_size: pageSize },
  });
  return res.data;
};

export const getWalletSummary = async () => {
  const res = await api.get('/wallet/summary');
  return res.data;
};
